import {
  ProductPriceInfo,
  productPriceInfoFromResponse,
} from '../Product/ProductPriceInfo';
import {
  ProductImage,
  productImageFromResponse,
} from '../Product/ProductImage';

export interface BasketProduct {
  id: number;
  slug: string;
  name: string;
  specialPrice: ProductPriceInfo;
  baseImage: ProductImage;
}

export const basketProductFromResponse = (
  responseData: any,
): BasketProduct => ({
  id: responseData.id,
  slug: responseData.slug,
  name: responseData.name,
  specialPrice: productPriceInfoFromResponse(responseData.special_price),
  baseImage: productImageFromResponse(responseData.base_image),
});
